const strip_punctuation = (str: string): string => {
    return str.replace(/[;"]/g, "").replace(/\s+/g, " ");
};
export default strip_punctuation;
